import { gql } from 'graphql-tag'
import { get } from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import Modal from '../../../common/modal/Modal'
import Select from '../../../common/select/Select'
import { i18n } from '../../index'
import MonthDisplay from '../MonthDisplay'
import css from './totalSales.css'
import TotalSalesGraph from './TotalSalesGraph'
import TotalSalesTable from './TotalSalesTable'
import { TotalSalesNote } from './types'
const fetchTotalSalesQuery = gql`
  query fetchTotalSales($stationId: ID!, $year: Int!, $month: Int!, $profitCenter: Int) {
    fetchTotalSales(stationId: $stationId, year: $year, month: $month, profitCenter: $profitCenter) {
      budget {
        date
        budget
        totalSales
        totalSalesLastYear
        note
      }
    }
  }
`

type Props = {
  stationId: string
  options: Array<Record<string, any>>
}

type State = {
  selectedMonth: moment.Moment
  selectedOption?: Record<string, any>
  spotlight?: TotalSalesNote
  editable?: boolean
}

const getDefaultData = (selectedMonth) => {
  const [month, year] = selectedMonth.format('MM-YYYY').split('-')
  return {
    budget: Array(selectedMonth.daysInMonth())
      .fill(null)
      .map((_, index) => {
        return {
          budget: 0,
          note: '',
          totalSales: 0,
          totalSalesLastYear: 0,
          date: moment()
            .year(year)
            .month(month - 1)
            .date(index + 1)
            .format('YYYY-MM-DD'),
        }
      }),
  }
}

export default class TotalSalesPage extends Component<Props, State> {
  state = {
    selectedMonth: moment(),
    selectedOption: this.props.options[0],
    spotlight: undefined,
  }
  clearSpotlight = () => {
    this.setState({
      spotlight: undefined,
    })
  }
  setSpotlight = (data: TotalSalesNote) => () => {
    this.setState({
      spotlight: data,
    })
  }
  onOptionChange = (name: string) => {
    const selectedOption = this.props.options.find((option) => option.name === name)
    this.setState({
      selectedOption,
      editable: false,
    })
  }
  onMonthChange = (step: number) => {
    this.setState({
      selectedMonth: this.state.selectedMonth.clone().add(step, 'months'),
    })
  }

  render() {
    const { stationId, options } = this.props
    const { spotlight, selectedMonth, selectedOption } = this.state
    const [month, year] = selectedMonth.format('MM-YYYY').split('-')
    const variables: { stationId: string; year: number; month: number; profitCenter?: number } = {
      stationId,
      year: Number(year),
      month: Number(month),
    }

    if (selectedOption.name !== 'Yhteensä') {
      variables.profitCenter = +selectedOption.id
    }

    return (
      <div>
        <div className={css.selectorLabel}>{i18n.t('reporting.profitCenter')}</div>
        <Select
          className={css.typeSelect}
          options={options.map((option) => ({ ...option, value: option.name }))}
          getOptionLabel={(option) => option.value}
          getOptionValue={(option) => option}
          value={selectedOption.name}
          onChange={(option) => this.onOptionChange(option.name)}
        />
        <MonthDisplay selectedMonth={selectedMonth} onMonthChange={this.onMonthChange} />
        <Query query={fetchTotalSalesQuery} variables={variables}>
          {({ loading, error, data }) => {
            const dbData = get(data, 'fetchTotalSales', getDefaultData(selectedMonth))
            const budgetData = dbData.budget.length > 0 ? dbData : getDefaultData(selectedMonth)
            return (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <Modal spotlight={spotlight} clearSpotlight={this.clearSpotlight} />
                <TotalSalesTable handleSelectNote={this.setSpotlight} data={budgetData} />
                <TotalSalesGraph month={Number(month)} year={Number(year)} data={budgetData} />
              </Loader>
            )
          }}
        </Query>
      </div>
    )
  }
}
